<template>
	<div class="notice-content">
		<div class="setting-top-box">
			<button class="btn-primary-ghost btn-xs fr" @click="$router.back()">返回</button>
			<span class="setting-top-title">系统消息</span>
		</div>
		<div class="notice-box">
			<div class="notice-title">{{pageData.title}}</div>
			<div class="notice-time">{{pageData.releaseTimestamp | time}}</div>
			<div class="article__html" v-html="pageData.content"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pageData: {}
			}
		},
		created() {
			this.sysMsgDetail();
		},
		methods: {
			async sysMsgDetail() {
				let res = await this.$http('sysMsgDetail', this.$route.params.contentId);
				if(res.code === 1){
					this.pageData = res.data;
				}
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.notice-content{
		.notice-title{
			font-size: 36px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #414141;
			line-height: 50px;
			text-align: center;
		}
		.notice-time{
			text-align: center;
			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #9C9C9C;
			line-height: 18px;
		}
		.article__html{
			padding-left: 0;
			padding-right: 0;
			p{
				margin: 5px 0;
			}

		}
		.notice-box{
			padding: 40px 50px;
		}
	}
</style>
